module.exports = __webpack_public_path__ + "img/alipay-gray-icon.5f4a9fee.png";